<template>
  <div class="hotelux-current-user">
    <div v-if="!user" class="auth-buttons">
      <div class="register-btn" plain @click="handleRegister">
        {{ $t("shared.auth.register") }}
      </div>
      <y-button class="signin-btn" @click="handleSignIn">
        {{ $t("shared.auth.signIn") }}
      </y-button>
    </div>

    <div v-else class="user-info" @click="emit('member')">
      <span class="user-name">{{ user.name }}</span>
      <div class="user-avatar">
        <img :src="AvatarRef" alt="avatar" />
        <img
          v-if="memberLevel"
          class="member-level"
          :src="memberLevel"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { useLoginRedirect } from "@/hooks/useLoginRedirect";
import { useUserStoreHook } from "@/store/modules/user";

import defaultAvatar from "./icon-head.png";

defineProps({
  settings: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(["member"]);

const router = useRouter();
const route = useRoute();
const userStore = useUserStoreHook();
const yChannelStore = useYChannelStoreHook();
const { redirectToLogin } = useLoginRedirect();
const { user } = storeToRefs(userStore);

const memberLevel = computed(() => {
  return yChannelStore.configs?.level[
    user.value?.loyaltyProgram?.ref?.type || "guest"
  ];
});

const handleSignIn = () => {
  redirectToLogin(route.fullPath);
};

const AvatarRef = computed(() => {
  return user.value?.photoUrls[0] ? user.value.photoUrls[0] : defaultAvatar;
});

const handleRegister = () => {
  const redirectUrl = route.fullPath;
  if (yChannelStore.configs?.registerToSelectPage) {
    router.push({
      path: "/channel-select",
      query: {
        tab: "register",
        redirect: redirectUrl
      }
    });
  } else {
    router.push({
      path: "/login",
      query: {
        tab: "register",
        redirect: redirectUrl,
        ...route.query
      }
    });
  }
};

defineOptions({
  name: "HoteluxCurrentUser"
});
</script>

<style lang="scss" scoped>
.hotelux-current-user {
  display: flex;
  align-items: center;
  color: inherit;
}

.auth-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}

.signin-btn {
  min-width: 97px;
  height: 40px;
  padding: 0 24px;
  font-family: Lato, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 1px;
  border-radius: 0;
  transition: all 0.3s ease;

  background: rgba(255, 255, 255, 0.1);

  backdrop-filter: blur(2.5px);
  -webkit-backdrop-filter: blur(2.5px);

  border: 1px solid rgba(255, 255, 255, 0.2);

  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.register-btn {
  color: #ffffff;
  background: transparent;
  text-transform: uppercase;
  font-family: lato;
  font-size: 14px;
  letter-spacing: 1px;
  &:hover {
    background: rgb(255 255 255 / 10%);
  }
}

.signin-btn {
  color: #fff;
  // background: #212223;
  // border: 1px solid #212223;

  // &:hover {
  //   background: #000;
  //   border-color: #000;
  // }
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
}

.user-name {
  font-family: "lato-bold";
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: inherit;
}

.user-avatar {
  position: relative;
  width: 40px;
  height: 40px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }

  .member-level {
    position: absolute;
    // top: 22px;
    bottom: -2px;
    left: 50%;
    width: auto;
    height: 14px;
    transform: translateX(-50%);
    border-radius: 0;
  }
}
</style>
